import React from "react";
import { MinusIcon, AddIcon } from "@chakra-ui/icons";
import StarRatings from "react-star-ratings";
import moment from "moment";

import {
  Box,
  Heading,
  Link,
  Image,
  Text,
  Divider,
  HStack,
  Tag,
  SpaceProps,
  useColorModeValue,
  Container,
  VStack,
  Collapse,
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Button,
  Avatar,
  useDisclosure,
  Spinner,
  Stack,
} from "@chakra-ui/react";
import AddReviewModal from "../../../utils/AddReviewModal";
import ReviewList from "../../../utils/ReviewList";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  deleteGovernmentFeedback,
  getGovernment,
  submitGovernmentFeedback,
} from "../../../redux/actions/data/DataActions";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../../redux/Store";
import { useState } from "react";

const GovernmentView = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [govReviewCount, setgovReviewCount] = useState(0);
  const [avgRatingCount, setAvgRatingCount] = useState(0);
  const [show, setShow] = React.useState(false);
  const { GovernmentID }: { GovernmentID: string } = useParams();
  const dispatch = useDispatch();
  const handleToggle = () => setShow(!show);
  useEffect(() => {
    dispatch(getGovernment(GovernmentID));
    window.scrollTo(0, 0);
  }, [GovernmentID]);
  const dataState = useSelector((state: RootStore) => state.data);
  const government = dataState?.governmentData?.government;
  const uiState = useSelector((state: RootStore) => state.ui);
  const govLoading = uiState.governmentLoading;
  const govReview = government?.reviews;

  useEffect(() => {
    let avgRating: number = 0;
    setgovReviewCount(Number(govReview?.length));
    for (let i = 0; i < Number(govReview?.length); i++) {
      if (govReview != undefined) {
        avgRating += Number(govReview[i].rating);
      }
    }
    if (Number(govReview?.length)) {
      setAvgRatingCount(avgRating / Number(govReview?.length));
    }
  }, [govReview]);

  return (
    <>
      {govLoading ? (
        <Image src="/Loading.gif" padding="100" margin="auto" />
      ) : (
        <Container
          maxW={"7xl"}
          marginTop={"5"}
          marginBottom={"5"}
          id="GovernmentViewContainer"
        >
          <Box
            marginTop={{ base: "1", sm: "5" }}
            display="flex"
            flexDirection={{ base: "column", sm: "row" }}
            justifyContent="space-between"
          >
            <Box
              display="flex"
              flex="1"
              marginRight="3"
              position="relative"
              alignItems="center"
            >
              <Box
                width={{ base: "100%", sm: "85%" }}
                zIndex="2"
                marginLeft={{ base: "0", sm: "5%" }}
                marginTop="5%"
              >
                <Link textDecoration="none" _hover={{ textDecoration: "none" }}>
                  <Image
                    borderRadius="lg"
                    src={government?.image}
                    alt={government?.name}
                    objectFit="contain"
                  />
                </Link>
              </Box>
              <Box zIndex="1" width="100%" position="absolute" height="100%">
                <Box
                  // bgGradient={useColorModeValue(
                  //   "radial(orange.600 1px, transparent 1px)",
                  //   "radial(orange.300 1px, transparent 1px)"
                  // )}
                  backgroundSize="20px 20px"
                  opacity="0.4"
                  height="100%"
                />
              </Box>
            </Box>
            <Box
              display="flex"
              flex="1"
              flexDirection="column"
              justifyContent="center"
              marginTop={{ base: "3", sm: "0" }}
              textAlign="justify"
            >
              <HStack spacing={2} marginBottom="1">
                <StarRatings
                  starDimension="15px"
                  style={{
                    margin: "0",
                    padding: "0",
                  }}
                  starSpacing="0px"
                  starRatedColor="#D10024"
                  numberOfStars={5}
                  name="rating"
                  rating={avgRatingCount}
                />
                <Text size={"md"} fontWeight="bold">
                  {String(govReviewCount)} reviews
                </Text>
              </HStack>
              <HStack spacing={2} marginBottom="1">
                <Tag size={"md"} variant="solid" colorScheme="red">
                  {government?.majority?.country?.name}
                </Tag>
                <Tag size={"md"} variant="solid" colorScheme="orange">
                  {government?.majority?.name}
                </Tag>
                <Tag size={"md"} variant="solid" colorScheme={"yellow"}>
                  {government?.status}
                </Tag>
              </HStack>

              <Heading textAlign="left">
                <Text>{government?.name}</Text>
              </Heading>
              <HStack>
                <Text fontWeight="bold" m="0.5">
                  Tenure
                </Text>
                <Tag
                  size={"md"}
                  variant="solid"
                  colorScheme={"green"}
                  textColor="white"
                >
                  {government?.tenure}{" "}
                </Tag>
              </HStack>
              <HStack>
                <Text fontWeight="bold" m="0.5">
                  Government Type
                </Text>
                <Tag
                  size={"md"}
                  variant="solid"
                  colorScheme={"facebook"}
                  textColor="white"
                >
                  {government?.governmentType}
                </Tag>
              </HStack>
              <HStack>
                <Text color="black" fontWeight="bold" m="0.5">
                  Man On Incharge{" "}
                </Text>
                <Tag
                  size={"md"}
                  variant="solid"
                  colorScheme={"telegram"}
                  textColor="white"
                >
                  {government?.manOnIncharge}{" "}
                </Tag>
              </HStack>

              <Collapse startingHeight={100} in={show}>
                {government?.description?.substring(0, 450)}...
              </Collapse>
              <Button
                size="sm"
                onClick={handleToggle}
                width="fit-content"
                background="dodgerblue"
                color="white"
                marginTop="2.5"
                _hover={{
                  color: "black",
                  bg: "#CBD5E0",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
              >
                Show {show ? "Less" : "More"}
              </Button>
            </Box>
          </Box>
          <Accordion allowToggle marginTop="5">
            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton
                      _focus={{
                        outline: "none",
                        boxShadow: "none",
                        textDecor: "none",
                      }}
                      _expanded={{ bg: "#D10024", color: "white" }}
                    >
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="bold" fontSize="lg">
                          More about this government
                        </Text>
                      </Box>
                      {isExpanded ? (
                        <MinusIcon fontSize="12px" />
                      ) : (
                        <AddIcon fontSize="12px" />
                      )}
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} textAlign="justify">
                    {government?.description}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton
                      _focus={{
                        outline: "none",
                        boxShadow: "none",
                        textDecor: "none",
                      }}
                      _expanded={{ bg: "#1E1F29", color: "white" }}
                    >
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="bold" fontSize="lg">
                          More about {government?.majority?.name}
                        </Text>
                      </Box>
                      {isExpanded ? (
                        <MinusIcon fontSize="12px" />
                      ) : (
                        <AddIcon fontSize="12px" />
                      )}
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} textAlign="justify">
                    {government?.majority?.description}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>

            <AccordionItem>
              {({ isExpanded }) => (
                <>
                  <h2>
                    <AccordionButton
                      _focus={{
                        outline: "none",
                        boxShadow: "none",
                        textDecor: "none",
                      }}
                      _expanded={{ bg: "#D10024", color: "white" }}
                    >
                      <Box flex="1" textAlign="left">
                        <Text fontWeight="bold" fontSize="lg">
                          More about {government?.majority?.country?.name}
                        </Text>
                      </Box>
                      {isExpanded ? (
                        <MinusIcon fontSize="12px" />
                      ) : (
                        <AddIcon fontSize="12px" />
                      )}
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} textAlign="justify">
                    {government?.majority?.country?.description}
                  </AccordionPanel>
                </>
              )}
            </AccordionItem>
          </Accordion>
          <VStack margin="5" alignItems="flex-start">
            <HStack width="full">
              <Text fontWeight="bold" fontSize="xl">
                Reviews
              </Text>

              <Button
                id="AddReviewButton"
                bg="white"
                _hover={{ bg: "#D10024", color: "white" }}
                variant="solid"
                color="orange"
                border="1px"
                borderRadius="5px"
                onClick={onOpen}
                style={{
                  marginLeft: "auto",
                }}
                _focus={{
                  outline: "none",
                  boxShadow: "none",
                  textDecor: "none",
                }}
              >
                Add Review
              </Button>
            </HStack>

            <AddReviewModal
              _id={government?._id}
              isOpen={isOpen}
              onClose={onClose}
              submitFeedbackFunc={submitGovernmentFeedback}
            />

            <Divider dashed color="gray" />

            {government?.reviews?.map((review) => (
              <ReviewList
                rootId={String(government._id)}
                _id={review?._id}
                user={review?.user}
                review={review?.review}
                rating={review?.rating}
                date={review?.date}
                deleteFunc={deleteGovernmentFeedback}
              />
            ))}
          </VStack>
        </Container>
      )}
    </>
  );
};

export default GovernmentView;
